import querystring from 'querystring';

const querystringToObj = (query?: string) => {
  let qs = query ?? window?.location?.search ?? '';
  if (qs.startsWith('?')) {
    qs = qs.substr(1);
  }
  return querystring.parse(qs);
};

export default querystringToObj;
